<div class="nav_menu without_top_omne_bar pdl-0">
   <div class="custom_container">
      <div class="row">
         <div class="side_menu pd-0 d-flex align-items-center justify-content-center">
            <img src="../assets/images/icons/ic-menu.svg" alt="ic-menu" />
         </div>
         <div class="page_title active h-100 d-flex align-items-center">PLACE</div>
         <div class="page_title h-100 d-flex align-items-center">Vendor - {{VendorName}}</div>
      </div>
   </div>
</div>
<!-- main nav bar -->
<!-- sidebar_left -->
<div class="leftSideBar pt_4 pb_4 pdx-0">
   <div class="sideNavItems">
       <ul>
           <li>
               &nbsp;
               <!-- <a class="text_14" data-tooltip="E-sign Dashboard" data-tooltip-location="right">
                   <span class="sideNavItems--icon">
                       <img src="../assets/images/icons/ic-dashboard.svg" alt="ic-cfirst" />
                   </span>
                   <span class="sideNavItems--text">E-sign Dashboard</span>
               </a> -->
           </li>
       </ul>
   </div>
</div>
<!-- sidebar_left -->
<ng-container>
   <app-secondary-navbar></app-secondary-navbar>
</ng-container>
<div class="custom_body_wrap custom_container with-top-omnebar with-top-navmenu with-left-sidenav">
   <router-outlet></router-outlet>
</div>
   
<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
   <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner> -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="small" fullScreen="false" color="#fff"
   template="<img src='~/../assets/images/square-loader.gif' width='200px' height='200px' />">
</ngx-spinner>





